<template>
  <div class="menu-button-container">
    <el-dropdown
      :hide-on-click="false"
      placement="bottom-start"
      popper-class="el-dropdown__popper menu-dropdown"
      trigger="click"
    >
      <el-button class="el-dropdown-link white-button menu-button">
        <custom-icon
          icon-type="menu"
        />
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="option in options"
            :key="option.id"
          >
            <router-link
              v-if="option.type === 'link'"
              class="menu-item"
              :class="[option.type, option.id]"
              :to="{ name: option.id, query: queryObj }"
            >
              {{ option.name }}
            </router-link>
            <button
              v-else-if="option.type === 'button'"
              class="bg-white text-primary w-full cursor-pointer"
              :class="[option.id]"
              style=" padding: 16px 0; height: auto;border:0;"
              type="button"
              @click="option.fn"
            >
              <span class="text-[16px]">{{ option.name }}</span>
            </button>
            <div
              v-else
              class="menu-item"
              :class="[option.type, option.id]"
            >
              {{ option.name }}
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import liff from '@line/liff'
import { get } from 'lodash-es'

import { useStoreCname } from '@/composables/useStoreCname'
import {
  getLocalStorage,
  getUserLocalStorage,
  removeUserLocalStorage,
} from '@/utils'

const route = useRoute()
const store = useStore()
const storeCname = useStoreCname()
const queryObj = computed(() => route.query)
const designerId = computed(() => get(queryObj.value, 'userId', null))

const options = computed(() => {
  const menu = [
    { name: '首頁', id: 'Store', type: 'link' },
    { name: '會員中心', id: 'UserProfile', type: 'link' },
  ]

  const serviceEnable = store.getters['store/serviceEnable']
  const retailEnable = store.getters['store/retailEnable']

  if (serviceEnable) {
    menu.push({ name: '線上預約', id: 'StoreMenu', type: 'link' })
  }
  if (retailEnable) {
    menu.push({ name: '店販銷售', id: 'StoreRetail', type: 'link' })
  }

  // 只有測試環境能使用
  if (!['production', 'beta'].includes(import.meta.env.VITE_NODE_ENV)) {
    const authData = getUserLocalStorage({ cname: storeCname.value })
    if (authData) {
      menu.push({
        name: '登出 token',
        id: 'logout',
        type: 'button',
        fn: () => logout(),
      })
    }

    if (liff.isInClient()) {
      menu.push({
        name: '登出 LIFF',
        id: 'logoutLIFF',
        type: 'button',
        fn: () => logoutLiff(),
      })
    }
  }

  return menu.concat([
    { name: '服務條款', id: 'Terms', type: 'link' },
    { name: `v${import.meta.env.VITE_APP_VERSION}`, id: 'Version' },
  ])
})

const logout = () => {
  removeUserLocalStorage({ cname: storeCname.value })
  window.location.reload()
}

const logoutLiff = async () => {
  const storeData = getLocalStorage('Store')
  if (storeData?.liffId) {
    await liff.init({ liffId: storeData.liffId }).catch(() => {})
    if (liff.isLoggedIn()) {
      liff.logout()
    }
  }
}

onMounted(() => {
  store.dispatch('store/getStore', {
    code: storeCname.value,
    ...(designerId.value ? { userId: designerId.value } : null),
  })
})
</script>
